import { createRoute } from '@/utils/routing'

export const USER_LIST_ROUTE = 'users'

export function createUserListRoute (options = {}) {
  return createRoute(USER_LIST_ROUTE, options)
}
